// extracted by mini-css-extract-plugin
export var animationContainer = "_dm-0";
export var asteriskIcon = "_dm-8";
export var conversationLeftSection = "_dm-4";
export var conversationListItem = "_dm-3";
export var conversationMiddleSection = "_dm-5";
export var conversationRightSection = "_dm-6";
export var detailsContent = "_dm-1";
export var listContainer = "_dm-7";
export var modalContent = "_dm-2";